import { render, staticRenderFns } from "./GYSZhiAdd.vue?vue&type=template&id=74637aa0&scoped=true&"
import script from "./GYSZhiAdd.vue?vue&type=script&lang=js&"
export * from "./GYSZhiAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74637aa0",
  null
  
)

export default component.exports